<template>
  <div>
    <h-section-header back='/dashboard'>
      {{client.first_name}}'s Pulses
    </h-section-header>
    <div class="card-rows">
      <div class="card card--transparent full-width">
        <h1 style="text-align: center">Percent of Completed Exercises</h1>
        <completed style="height: 30vh; min-height: 200px" :userId="$route.params.id" />
      </div>
      <kpi :kpi="kpi" v-for="kpi in kpis" :key="kpi.id"/>
      <well-being v-for="(values, title) in graphs"
        :title="title"
        :computedData="values.data"
        :color="values.graph_color"
        :key="title"
        />
    </div>
  </div>
</template>

<script>
import modal from "@/components/modal";
import kpiChart from "@/components/kpiChart";
import axios from "axios";
import completed from "@/components/charts/completed";
import wellBeing from "@/components/charts/wellBeing";

export default {
  props: ["client"],
  components: {
    kpi: kpiChart,
    wellBeing,
    modal,
    completed,
  },
  data() {
    return {
      loadingWord: true,
      loadingKPIs: true,
      loadingCharts: true,
      graphs: {},
      kpis: [],
      chartEndPoint: `${process.env.VUE_APP_API_URL}clients/surveys/info/`,
    };
  },
  created() {
    let clientId = this.$route.params.id;
    axios.get(`${process.env.VUE_APP_API_URL}coaches/kpis/chart_info/`, {params: {client: clientId}})
      .then(({ data }) => {
        this.kpis = data;
      });

    let chartEndPoint = `${ process.env.VUE_APP_API_URL }coaches/clients/${clientId}/info/`;
    axios
      .get(chartEndPoint)
      .then(({ data }) => {
        this.graphs = data;
        this.loading = false;
      })
      .finally(() => {
        this.$emit("finished");
      });
  },
};
</script>